export function numericToNumber(value: unknown): number {
  if (typeof value === 'number') {
    return value;
  }

  if (value == null) {
    return 0;
  }

  return Number(value);
}

export function formatAmount(amount?: number | null, currency?: string | null): string {
  if (amount == null) {
    return '';
  }

  const amountString = amount
    .toLocaleString('af', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    .replace(',', '.');

  return `${currency ? `${currency}\u00a0` : ''}${amountString}`;
}

export function formatPercent(value?: number | null, fractionDigits: number = 1): string {
  if (value == null) {
    return '';
  }

  return `${(value * 100).toFixed(fractionDigits)}%`;
}
